import React, { ReactElement } from 'react';
import { EContainerIconSize, EIconSize } from 'utils/constants/app/ui';
import { EventAction } from 'components/EventAction';
import { GlobalIcon } from 'components/GlobalIcon';
import './index.less';

type TVideoCamIconProps = {
  size?: EIconSize._14 | EIconSize._16 | EIconSize._20;
  iconContainerSize?:
    | EContainerIconSize.SMALL
    | EContainerIconSize.MIDDLE
    | EContainerIconSize.LARGE
    | 0;
  className?: string;
  marginDirection?: 'left' | 'right' | null;
};

export const VideoCamIcon = ({
  size,
  iconContainerSize,
  className,
  marginDirection = 'left'
}: TVideoCamIconProps): ReactElement => {
  return (
    <EventAction
      margin={marginDirection}
      iconContainerSize={iconContainerSize}
      icon={
        <GlobalIcon
          lib="generic"
          name="videoCam"
          theme="default"
          size={size}
          className={className}
        />
      }
    />
  );
};
